import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  MENÜSZERKESZTŐ – a bal oldali menü átrendezése húzással.
 *
 *  A menü szerkezete adatbázisban él (sorrend, csoportba sorolás, cím, ikon), és
 *  eddig csak SQL-ből lehetett átrendezni. Ez kockázatos is: a csoportba sorolás
 *  a szülő sor AZONOSÍTÓJÁRA hivatkozik, egy elgépelt id pedig elárvítja a
 *  menüpontot – az némán eltűnik a menüből.
 *
 *  AMI ITT SZERKESZTHETŐ, ÉS AMI NEM:
 *
 *   - az ELRENDEZÉS (sorrend, csoport, cím, ikon) alapból intézményenként közös.
 *     Kiválasztott jogkörnél a húzás, az átnevezés és az ikon CSAK annak a
 *     jogkörnek a saját elrendezésébe kerül (menu_elrendezes) – nem öröklődik, a
 *     pedagógus átrendezése tehát az admin oldalsávját sem írja át. Új menüpont,
 *     törlés, tiltás és „új oldalon" a közös szerkezet része.
 *   - a LÁTHATÓSÁG jogkörönként dől el. Ha kiválasztasz egy jogkört, a lista az
 *     ő szemével látszik, és soronként ki-be kapcsolható – ugyanazokat a sorokat
 *     írja, mint a Jogosultságok képernyő, mert két külön író ugyanarra a táblára
 *     előbb-utóbb két különböző szabályt jelentene.
 */
@Component({
  selector: 'app-admin-menuszerkeszto',
  templateUrl: './menuszerkeszto.component.html',
  styleUrls: ['./menuszerkeszto.component.scss'],
})
export class AdminMenuszerkesztoComponent implements OnInit {

  alrendszerek: string[] = [];
  alrendszer = '';
  intezmeny = '';

  toltodik = false;
  mentesFut = false;
  hiba = '';

  /** A fa: felső szintű elemek, a fejlécek alatt gyerekekkel. */
  felso: any[] = [];
  jogkorok: any[] = [];
  mindentLato: string[] = [];

  /** jogkör → a látható url-ek halmaza (access-sorok). */
  private lathatosag: { [jogkor: string]: Set<string> } = {};
  /*  jogkör → az ELREJTETT url-ek halmaza.
   *
   *  Az elrejtés nem jogosultság: külön nyilvántartás, és csak a menü
   *  kirajzolására hat. Ez teszi lehetővé, hogy a mindent látó (csillag jogú)
   *  jogkörnél is el lehessen venni egy menüpontot anélkül, hogy a hozzáférés
   *  megszűnne – a képernyő közvetlen hivatkozással továbbra is megnyílik.
   */
  private rejtve: { [jogkor: string]: Set<string> } = {};

  /** Melyik jogkör szemével nézzük. Üres = csak a szerkezetet szerkesztjük. */
  nezoJogkor = '';

  /*  A közös szerkezet nyers sorai és a jogkörönkénti felülírások (jogkör → menü-id →
   *  { main, sorrend, title, icon }). A fa ezekből épül a kiválasztott jogkör szerint. */
  private nyersTetelek: any[] = [];
  private elrendezes: { [jogkor: string]: { [menuId: string]: any } } = {};

  /** Van-e a kiválasztott jogkörnek saját (mentett) elrendezése. */
  get sajatElrendezes(): boolean {
    return !!this.nezoJogkor && Object.keys(this.elrendezes[this.nezoJogkor] || {}).length > 0;
  }

  jogkorNev(jk: string): string {
    return this.jogkorok.find((j) => j.jogkor === jk)?.name || jk;
  }

  /*  Jogkör-váltás. A fa a jogkör saját elrendezése szerint épül újra – a mentetlen
   *  átrendezés ezzel elveszne, ezért előbb rákérdezünk. */
  nezoValt(uj: any) {
    const jk = Array.isArray(uj) ? (uj[0] || '') : (uj || '');
    if (jk === this.nezoJogkor) return;
    if (this.piszkos && !confirm('A mentetlen átrendezés (sorrend, csoport, név, ikon) elvész. Váltasz?')) {
      //  Az ion-select már átállt – vissza kell billenteni a megjelenített értéket.
      const regi = this.nezoJogkor; this.nezoJogkor = '__'; setTimeout(() => { this.nezoJogkor = regi; });
      return;
    }
    this.nezoJogkor = jk;
    this.piszkos = false;
    this.torlendo.clear();
    this.faEpit(this.nyersTetelek);
  }

  /** A kiválasztott jogkör saját elrendezésének törlése – onnantól a közös érvényes rá. */
  async elrendezesVissza() {
    if (!this.nezoJogkor) return;
    if (!confirm(`Törlöd a(z) „${this.jogkorNev(this.nezoJogkor)}" jogkör saját menü-elrendezését? `
      + 'Utána a közös szerkezet érvényes rá.')) return;
    this.mentesFut = true;
    try {
      await firstValueFrom(this.http.delete(
        `/api/jogosultsag/menu-elrendezes/${encodeURIComponent(this.alrendszer)}/${this.intezmeny}`,
        { params: { jogkor: this.nezoJogkor } }));
      this.data.sendToast('A közös elrendezés érvényes erre a jogkörre.', 'success');
      const jk = this.nezoJogkor;
      await this.betolt();
      this.nezoJogkor = jk;
      this.faEpit(this.nyersTetelek);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszaállítás nem sikerült.', 'error');
    } finally {
      this.mentesFut = false;
    }
  }

  /*  ÚJ MENÜPONT.
   *
   *  Az azonosítót a kiszolgáló adja, ezért a mentésig ideiglenes jelet kap („uj-1"),
   *  és `uj: true`-val megy át. Így egy mentésben létre lehet hozni egy csoportot és
   *  rögtön beletenni egy menüpontot – a kiszolgáló a fejléceket veszi előre. */
  ujNyitva = false;
  private ujSzamlalo = 0;
  ujTetel: any = { title: '', url: '', icon: '', fejlec: false, external: false, main: '' };

  /** Van-e mentetlen szerkezeti változás. */
  piszkos = false;
  /*  A KÉT MŰVELET KÜLÖN GYŰLIK.
   *
   *  Az elrejtés és a jogosultság két gyökeresen különböző dolog: az egyik csak az
   *  oldalsávot rendezi, a másik elveszi a hozzáférést. Egy közös listában
   *  összekeverednének, és a mentés nem tudná, melyiket kérted.
   */
  private jogValtozasok = new Map<string, boolean>();      // "jogkor||url" → van-e joga
  private rejtesValtozasok = new Map<string, boolean>();   // "jogkor||url" → rejtve legyen-e

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const sajat = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = sajat?.intezmenyId || '';
    this.alrendszer = (await this.data.getFromStorage('currentMode')) || 'SULINFORM';
    try {
      this.alrendszerek = await firstValueFrom(
        this.http.get<string[]>('/api/jogosultsag/alrendszerek'));
    } catch { this.alrendszerek = [this.alrendszer]; }
    await this.betolt();
  }

  async betolt() {
    if (!this.alrendszer || !this.intezmeny) {
      this.hiba = !this.intezmeny
        ? 'Nincs kiválasztott intézmény. Válassz a fejlécben, vagy lépj ki és be.'
        : 'Nincs kiválasztott alrendszer.';
      this.felso = [];
      return;
    }
    this.toltodik = true;
    this.hiba = '';
    this.piszkos = false;
    this.jogValtozasok.clear();
    this.rejtesValtozasok.clear();
    this.torlendo.clear();
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/jogosultsag/menu-szerkeszto/${encodeURIComponent(this.alrendszer)}/${this.intezmeny}`));
      this.jogkorok = r?.jogkorok || [];
      this.mindentLato = r?.mindent_lato || [];
      this.lathatosag = {};
      Object.entries(r?.lathatosag || {}).forEach(([jk, urlok]: any) => {
        this.lathatosag[jk] = new Set(urlok as string[]);
      });
      this.rejtve = {};
      Object.entries(r?.rejtve || {}).forEach(([jk, urlok]: any) => {
        this.rejtve[jk] = new Set(urlok as string[]);
      });
      this.elrendezes = r?.elrendezes || {};
      this.nyersTetelek = r?.tetelek || [];
      this.faEpit(this.nyersTetelek);
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A menü nem tölthető be.';
      this.felso = [];
    } finally {
      this.toltodik = false;
    }
  }

  /*  A lapos sorokból fa.
   *
   *  A szülő nélküli („árva") gyerek FELSŐ SZINTRE kerül, nem tűnik el: pontosan
   *  ez a hiba, amit kézi átírással el lehet követni, és a szerkesztőnek meg kell
   *  mutatnia, nem elrejtenie.
   */
  private faEpit(nyers: any[]) {
    //  Kiválasztott jogkörnél annak a saját elrendezése (ha van) írja felül a közöset.
    const feluliras = (this.nezoJogkor && this.elrendezes[this.nezoJogkor]) || {};
    const tetelek = nyers.map((t) => {
      const f = feluliras[String(t.id)];
      return f ? { ...t, main: f.main, sorrend: f.sorrend, title: f.title || t.title, icon: f.icon || t.icon } : t;
    });
    const szerint = new Map<string, any>();
    tetelek.forEach((t) => szerint.set(t.id, { ...t, gyerekek: [] }));

    const felso: any[] = [];
    for (const t of tetelek) {
      const elem = szerint.get(t.id);
      const szulo = t.main ? szerint.get(t.main) : null;
      if (szulo && szulo.fejlec && szulo.id !== elem.id) szulo.gyerekek.push(elem);
      else felso.push(elem);
    }
    const rendez = (l: any[]) => l.sort((a, b) => (a.sorrend || 0) - (b.sorrend || 0));
    rendez(felso).forEach((e) => rendez(e.gyerekek));
    this.felso = felso;
  }

  /** A húzáshoz: minden lista azonosítója (a fejlécek gyerek-listái + a felső szint). */
  get listaAzonositok(): string[] {
    return ['felso', ...this.felso.filter((e) => e.fejlec).map((e) => 'cs-' + e.id)];
  }

  /* ── húzás ────────────────────────────────────────────────────────── */

  ejtFelso(ev: CdkDragDrop<any[]>) {
    this.ejt(ev, null);
  }

  ejtCsoport(ev: CdkDragDrop<any[]>, fejlec: any) {
    this.ejt(ev, fejlec);
  }

  private ejt(ev: CdkDragDrop<any[]>, ujSzulo: any) {
    const elem = ev.previousContainer.data[ev.previousIndex];
    // Csoportfejlécet nem lehet másik csoportba tenni: a menü egy szintig
    // csoportosít, a fejléc a fejlécben nem jelenne meg sehol.
    if (elem?.fejlec && ujSzulo) {
      this.data.sendToast('Csoportot nem lehet másik csoportba húzni.', 'warning');
      return;
    }
    if (ev.previousContainer === ev.container) {
      moveItemInArray(ev.container.data, ev.previousIndex, ev.currentIndex);
    } else {
      transferArrayItem(ev.previousContainer.data, ev.container.data,
        ev.previousIndex, ev.currentIndex);
      elem.main = ujSzulo ? ujSzulo.id : null;
    }
    this.piszkos = true;
  }

  /* ── szerkesztés ──────────────────────────────────────────────────── */

  modosult() { this.piszkos = true; }

  /** Kivétel a csoportból, húzás nélkül – érintőképernyőn ez a használható út. */
  felsobe(elem: any, fejlec: any) {
    fejlec.gyerekek = fejlec.gyerekek.filter((g: any) => g.id !== elem.id);
    elem.main = null;
    this.felso.push(elem);
    this.piszkos = true;
  }

  /* ── láthatóság ─────────────────────────────────────────────────────
   *  Két külön kérdés, két külön kapcsoló:
   *
   *    JOGOSULTSÁG – megnyílik-e neki a képernyő. Ezt a Jogosultságok képernyő is
   *                  írja; csillag jogú jogkörnél nem soronként áll.
   *    ELREJTÉS    – ott van-e az oldalsávban. Csak a kirajzolásra hat, BÁRMELYIK
   *                  jogkörnél, és jogkör kiválasztása nélkül mindenkire.
   *
   *  Korábban egy gomb volt mindkettőre, és a kiszolgáló találgatta, melyiket
   *  akartad. Aki csak a saját menüjében akart rendet tenni, az elvette a
   *  kollégáitól a hozzáférést.
   */

  /** A '*' jogkör az elrejtésben MINDENKIT jelent (a szerkezet szintjén). */
  private readonly MINDENKI = '*';

  /** Mindent lát-e a kiválasztott jogkör (csillag joga van)? */
  get nezoMindentLat(): boolean {
    return !!this.nezoJogkor && this.mindentLato.includes(this.nezoJogkor);
  }

  /** Mindenki elől el van rejtve – jogkörtől függetlenül. */
  mindenkiElol(elem: any): boolean {
    return this.rejtve[this.MINDENKI]?.has(elem.url) || false;
  }

  /** Ez a jogkör elől el van rejtve (a mindenkire vonatkozó elrejtésen felül). */
  jogkorElol(elem: any): boolean {
    return !!this.nezoJogkor && (this.rejtve[this.nezoJogkor]?.has(elem.url) || false);
  }

  /** El van-e rejtve abban a nézetben, amit épp szerkesztünk. */
  rejtett(elem: any): boolean {
    return this.nezoJogkor ? (this.jogkorElol(elem) || this.mindenkiElol(elem)) : this.mindenkiElol(elem);
  }

  /** Saját (erre a jogkörre felvett) hozzáférés-sora van-e. */
  sajatJoga(elem: any): boolean {
    return !!this.nezoJogkor && (this.lathatosag[this.nezoJogkor]?.has(elem.url) || false);
  }

  /**
   *  ÖRÖKLÉS. A jogkör a `jogkor.link` láncon át megkapja a szülő jogköre engedélyeit
   *  is – a futásidejű feloldás pontosan így működik. A szerkesztő viszont csak a
   *  SAJÁT sorokat nézte, ezért az Osztályfőnököt választva minden szürkének látszott,
   *  holott a pedagógusi jogai élnek. Visszaadjuk, MELYIK jogkörtől örökli: az
   *  olvasónak az a hasznos információ, nem az, hogy „valahonnan".
   */
  oroklottJoga(elem: any): string | null {
    if (!this.nezoJogkor) return null;
    let szulo = this.jogkorok.find((j) => j.jogkor === this.nezoJogkor)?.link;
    const latott = new Set<string>();
    while (szulo && !latott.has(szulo)) {
      latott.add(szulo);
      if (this.mindentLato.includes(szulo) || this.lathatosag[szulo]?.has(elem.url)) return szulo;
      szulo = this.jogkorok.find((j) => j.jogkor === szulo)?.link;
    }
    return null;
  }

  /** Az öröklés forrásának megjelenítendő neve. */
  oroklottNev(elem: any): string {
    const jk = this.oroklottJoga(elem);
    if (!jk) return '';
    return this.jogkorok.find((j) => j.jogkor === jk)?.name || jk;
  }

  /** Megnyílik-e neki a képernyő. Ez a HOZZÁFÉRÉS, nem a menü. */
  vanJoga(elem: any): boolean {
    if (!this.nezoJogkor) return true;
    if (this.nezoMindentLat) return true;
    return this.sajatJoga(elem) || !!this.oroklottJoga(elem);
  }

  /** Megjelenik-e ténylegesen a menüben: van joga ÉS nincs elrejtve. */
  latja(elem: any): boolean {
    return this.vanJoga(elem) && !this.rejtett(elem);
  }

  /** Melyik kulcsra írjuk az elrejtést: a nézett jogkörre vagy mindenkire. */
  private get rejtesKulcs(): string {
    return this.nezoJogkor || this.MINDENKI;
  }

  /** Elrejtés ki-be. A jogosultságot NEM érinti – ezért működik minden jogkörnél. */
  rejtesValt(elem: any) {
    const jogkor = this.rejtesKulcs;
    /*  Ha a sort a „mindenki elől" elrejtés takarja, a jogkör-szintű kapcsoló
     *  önmagában nem hozná vissza. Ilyenkor azt oldjuk fel, amit a felhasználó lát.
     */
    const globalis = this.mindenkiElol(elem);
    const cel = this.nezoJogkor && globalis ? this.MINDENKI : jogkor;
    const most = this.rejtve[cel]?.has(elem.url) || false;

    const halmaz = this.rejtve[cel] || (this.rejtve[cel] = new Set<string>());
    if (most) halmaz.delete(elem.url); else halmaz.add(elem.url);
    this.rejtesValtozasok.set(`${cel}||${elem.url}`, !most);
  }

  /** Jogosultság ki-be. Csillag jogú jogkörnél nem soronként áll. */
  jogValt(elem: any) {
    if (!this.nezoJogkor || this.nezoMindentLat) return;
    const uj = !this.vanJoga(elem);
    const halmaz = this.lathatosag[this.nezoJogkor]
      || (this.lathatosag[this.nezoJogkor] = new Set<string>());
    if (uj) halmaz.add(elem.url); else halmaz.delete(elem.url);
    this.jogValtozasok.set(`${this.nezoJogkor}||${elem.url}`, uj);
  }

  /** Súgószöveg a jogosultság-gombra – a csillag jog külön eset. */
  jogCim(elem: any): string {
    if (this.nezoMindentLat) return 'Csillag joggal mindent lát – ez nem soronként áll. Elrejteni viszont lehet.';
    const orokolt = this.oroklottNev(elem);
    /*  Az öröklött jog nem itt keletkezett: ha a kolléga elveszi, csak SAJÁT tiltó
     *  sort nem tudunk írni – ezt előre meg kell mondani, különben úgy tűnne, hogy a
     *  kattintás nem csinál semmit. */
    if (!this.sajatJoga(elem) && orokolt) {
      return `Örökölt hozzáférés a(z) „${orokolt}" jogkörből – a kattintás SAJÁT jogot ad hozzá. `
        + 'Elvenni csak ott lehet, ahol keletkezett.';
    }
    return this.vanJoga(elem)
      ? 'Van hozzáférése – kattints a jogosultság elvételéhez'
      : 'Nincs hozzáférése – kattints a jogosultság megadásához';
  }

  /*  Súgószöveg az elrejtés-gombra.
   *
   *  A „mindenki elől" eset külön mondat: ha a sort az egész intézményre szóló
   *  elrejtés takarja, a kattintás MINDENKINEK visszahozza – nem csak ennek a
   *  jogkörnek. Ezt jobb előre kimondani, mint utólag magyarázni.
   */
  rejtesCim(elem: any): string {
    if (this.mindenkiElol(elem)) {
      return 'Mindenki elől elrejtve – a kattintás mindenkinek visszahozza. '
        + 'A jogosultság érintetlen.';
    }
    const kit = this.nezoJogkor ? 'ez elől a jogkör elől' : 'mindenki elől';
    return this.rejtett(elem)
      ? `Elrejtve ${kit} – kattints a megmutatáshoz. A jogosultság érintetlen.`
      : `Látszik a menüben – kattints az elrejtéshez ${kit}. A jogosultság megmarad.`;
  }

  /*  Figyelmeztetés: a gyerek nem látszik, ha a csoportfejléc nem látszik.
   *
   *  A menü a fejlécen keresztül rajzolja ki a csoportot; a rendszer ilyenkor
   *  felső szinten mutatja a gyereket, de a csoportosítás elvész. Jobb előre szólni,
   *  mint utólag keresni, miért „ugrál" a menü.
   */
  fejlecHiany(fejlec: any): boolean {
    return !this.latja(fejlec) && fejlec.gyerekek.some((g: any) => this.latja(g));
  }

  /* ── mentés ───────────────────────────────────────────────────────── */

  get menthet(): boolean {
    return (this.piszkos || this.jogValtozasok.size > 0 || this.rejtesValtozasok.size > 0
            || this.torlendo.size > 0)
      && !this.mentesFut;
  }

  /** A csoportfejlécek listája a szülő-választóhoz. */
  get fejlecek(): any[] { return (this.felso || []).filter((e) => e.fejlec); }

  ujMegnyit() {
    this.ujNyitva = !this.ujNyitva;
    if (this.ujNyitva) {
      this.ujTetel = { title: '', url: '', icon: '', fejlec: false, external: false, main: '' };
    }
  }

  /*  A KÜLSŐ HIVATKOZÁS mindig új ablakban nyílik – útvonalként értelmezve a rendszer
   *  a saját címei közt keresné, és üres képernyőt adna. Ezért ilyenkor a kapcsoló
   *  magától bekapcsol, és nem is vehető vissza. */
  get ujKulsoCim(): boolean { return /^https?:\/\//i.test(String(this.ujTetel.url || '').trim()); }

  ujFelvesz() {
    const title = String(this.ujTetel.title || '').trim();
    let url = String(this.ujTetel.url || '').trim();
    if (!title || !url) { this.data.sendToast('A név és az útvonal kötelező.', 'warning'); return; }

    const kulso = this.ujKulsoCim;
    if (this.ujTetel.fejlec && !url.startsWith('0/')) url = `0/${url.replace(/^\/+/, '')}`;
    if (!this.ujTetel.fejlec && !kulso && !url.startsWith('/')) url = `/${url}`;

    /*  Ütköző útvonalat nem engedünk: az url a menüpont azonossága, arra hivatkozik a
     *  jogosultság – két azonos url mellett nem lehetne megmondani, melyikre vonatkozik. */
    const mind = [...this.felso, ...this.felso.flatMap((e) => e.gyerekek || [])];
    if (mind.some((e) => String(e.url || '').toLowerCase() === url.toLowerCase())) {
      this.data.sendToast('Már van menüpont ezzel az útvonallal.', 'warning');
      return;
    }

    this.ujSzamlalo += 1;
    const elem: any = {
      id: `uj-${this.ujSzamlalo}`, uj: true,
      title, url,
      icon: String(this.ujTetel.icon || '').trim(),
      external: (kulso || this.ujTetel.external) ? 1 : 0,
      disabled: 0,
      fejlec: url.startsWith('0/'),
      main: null,
      gyerekek: [],
    };

    const szuloId = String(this.ujTetel.main || '');
    const szulo = !elem.fejlec && szuloId ? this.felso.find((e) => String(e.id) === szuloId) : null;
    if (szulo) { elem.main = szulo.id; (szulo.gyerekek = szulo.gyerekek || []).push(elem); }
    else this.felso.push(elem);

    this.modosult();
    this.ujNyitva = false;
    this.data.sendToast(elem.fejlec
      ? 'Csoport felvéve – mentés után jelenik meg.'
      : 'Menüpont felvéve. Mentés után add meg, mely jogkörök láthatják.', 'success');
  }

  /*  TÖRLÉSRE JELÖLT MENÜPONTOK.
   *
   *  A törlés nem azonnal hajtódik végre: a mentésig visszavonható, és egy menetben
   *  megy a többi módosítással. A sor addig áthúzva marad a listában – így látszik,
   *  mi fog eltűnni, nem pedig csendben kiürül a képernyő. */
  torlendo = new Set<string>();

  torlesreJelolt(elem: any): boolean { return this.torlendo.has(String(elem?.id)); }

  /**
   *  Menüpont törlése (mentéskor). Csoportfejlécnél előbb a gyerekeit kell máshová
   *  tenni vagy törölni: a fejléc nélkül maradt gyerek felső szintre ugrana, ami
   *  nem az, amit a kolléga akart – ezért inkább megmondjuk.
   */
  torlesValt(elem: any) {
    if (elem?.uj) { this.ujElvet(elem, this.felso.includes(elem) ? null : this.szulojeAnnak(elem)); return; }
    const id = String(elem?.id || '');
    if (!id) return;
    if (this.torlendo.has(id)) { this.torlendo.delete(id); this.modosult(); return; }

    const gyerekek = (elem.gyerekek || []).filter((gy: any) => !this.torlendo.has(String(gy.id)));
    if (gyerekek.length) {
      this.data.sendToast(`Ebben a csoportban még ${gyerekek.length} menüpont van. `
        + 'Előbb húzd ki őket máshová, vagy töröld azokat is.', 'warning');
      return;
    }
    if (!confirm(`Törlöd a(z) „${elem.title}" menüpontot?\n\n`
      + 'A hozzáférési jogokat NEM vesszük el: a képernyő közvetlen hivatkozással '
      + 'továbbra is megnyílik, csak a menüből tűnik el. A törlés a mentéskor '
      + 'hajtódik végre, addig visszavonható.')) return;
    this.torlendo.add(id);
    this.modosult();
  }

  /** Melyik felső szintű elem gyereke – az új sor elvetéséhez kell. */
  private szulojeAnnak(elem: any): any {
    return this.felso.find((e) => (e.gyerekek || []).includes(elem)) || null;
  }

  /** Mentés előtt felvett, még nem létező sor – egyszerűen kivehető. */
  ujElvet(elem: any, szulo: any = null) {
    const lista = szulo ? (szulo.gyerekek || []) : this.felso;
    const i = lista.indexOf(elem);
    if (i >= 0) lista.splice(i, 1);
    this.modosult();
  }

  /*  ÚJ OLDALON NYÍLJON-E MEG. Külső címnél nem kapcsolható vissza: útvonalként a
   *  rendszer a saját címei közt keresné. */
  kulsoCim(elem: any): boolean { return /^https?:\/\//i.test(String(elem?.url || '')); }
  externalValt(elem: any) {
    if (this.kulsoCim(elem)) {
      this.data.sendToast('Külső hivatkozás mindig új oldalon nyílik.', 'warning');
      return;
    }
    elem.external = elem.external ? 0 : 1;
    this.modosult();
  }

  async ment() {
    if (!this.menthet) return;
    this.mentesFut = true;
    try {
      if (this.piszkos) {
        /*  SORREND-SZÁMOZÁS.
         *
         *  A menüt a kiszolgáló egyetlen, lapos listaként adja vissza, sorrend
         *  szerint rendezve – a csoportosítás csak utána történik. Ezért a felső
         *  szint tízesével kap számot, a gyerekek pedig a szülőjük sávjában: így a
         *  mentett adatban is látszik, melyik csoportba tartoznak, és a globális
         *  rendezés sem keveri össze két csoport gyerekeit.
         */
        const tetelek: any[] = [];
        this.felso.forEach((e, i) => {
          const sorrend = (i + 1) * 10;
          tetelek.push({ id: e.id, main: null, sorrend, title: e.title, icon: e.icon,
                         disabled: e.disabled ? 1 : 0, external: e.external ? 1 : 0,
                         uj: !!e.uj, url: e.url });
          (e.gyerekek || []).forEach((gy: any, j: number) => {
            tetelek.push({ id: gy.id, main: e.id, sorrend: sorrend * 1000 + (j + 1) * 10,
                           title: gy.title, icon: gy.icon, disabled: gy.disabled ? 1 : 0,
                           external: gy.external ? 1 : 0, uj: !!gy.uj, url: gy.url });
          });
        });
        //  A törlésre jelölt sorokat a rendezésből is kivesszük: fölösleges lenne
        //  sorrendet írni annak, ami mindjárt megszűnik.
        const kuldheto = tetelek.filter((t) => !this.torlendo.has(String(t.id)));
        const sz: any = await firstValueFrom(this.http.put(
          `/api/jogosultsag/menu-szerkeszto/${encodeURIComponent(this.alrendszer)}/${this.intezmeny}`,
          this.nezoJogkor
            //  Kiválasztott jogkörnél CSAK az ő elrendezése íródik (új/törölt sor nélkül).
            ? { tetelek: kuldheto.filter((t) => !t.uj), torlendo: [], jogkor: this.nezoJogkor }
            : { tetelek: kuldheto, torlendo: [...this.torlendo] }));
        if (sz?.torolve) this.data.sendToast(`${sz.torolve} menüpont törölve.`, 'success');
        if (sz?.torles_kihagyva?.length) {
          this.data.sendToast(`${sz.torles_kihagyva.length} menüpont nem törölhető: `
            + `${sz.torles_kihagyva[0].ok}.`, 'warning');
        }
        this.torlendo.clear();
        /*  Amit a kiszolgáló nem tudott létrehozni, azt kimondjuk – a néma
         *  „nem történt semmi" a legrosszabb válasz. */
        if (sz?.kihagyva?.length) {
          this.data.sendToast(`${sz.kihagyva.length} új menüpont kimaradt: `
            + `${sz.kihagyva[0].url} – ${sz.kihagyva[0].ok}.`, 'warning');
        }
      }

      if (this.jogValtozasok.size || this.rejtesValtozasok.size) {
        /*  A kérés MEGMONDJA, melyik műveletet kéri – nem a kiszolgáló találgatja.
         *  Így az elrejtés soha nem vesz el jogosultságot, és fordítva.
         */
        const valtozasok = [
          ...[...this.rejtesValtozasok.entries()].map(([kulcs, rejtve]) => {
            const [jogkor, url] = kulcs.split('||');
            return { jogkor, url, rejtve };
          }),
          ...[...this.jogValtozasok.entries()].map(([kulcs, lathato]) => {
            const [jogkor, url] = kulcs.split('||');
            return { jogkor, url, lathato };
          }),
        ];
        const v: any = await firstValueFrom(this.http.put(
          `/api/jogosultsag/menu-lathatosag/${encodeURIComponent(this.alrendszer)}/${this.intezmeny}`,
          { valtozasok }));
        // Amit a kiszolgáló nem tudott elvégezni, azt kimondjuk – a néma
        // „nem történt semmi" a legrosszabb válasz.
        if (v?.kihagyva?.length) {
          this.data.sendToast(`${v.kihagyva.length} jogosultság-változás kimaradt: `
            + `${v.kihagyva[0].ok}.`, 'warning');
        }
      }

      this.data.sendToast('Mentve. A felhasználók a következő menüfrissítéskor látják.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.mentesFut = false;
    }
  }

  async elvet() {
    if (!this.menthet) return;
    if (!confirm('Elveted a mentetlen változtatásokat?')) return;
    await this.betolt();
  }
}
